module.exports = function (context, options) {
  $.extend(context, options.hash);
};
